// extracted by mini-css-extract-plugin
export default {"closeIcon":"banner_closeIcon__hU7rs"};